import React from 'react';
import clsx from 'clsx';

import { BaseComponentProps } from '@utils/types/baseComponents';
import { AmenityV2Enum } from '@components/_shared/amenityV2/constants';
import AmenityV2 from '@components/_shared/amenityV2/index';
import { ExpandAll } from '@assets/icons';

import styles from './styles.module.scss';

type Props = {
  items: (keyof typeof AmenityV2Enum | string)[];
  listStyle?: string;
  showAll?: boolean;
} & BaseComponentProps;

AmenitiesList.defaultProps = {
  listStyle: '',
  showAll: false,
};

export default function AmenitiesList(props: Props) {
  const { containerStyle, listStyle, items, showAll } = props;
  const [isExpanded, setIsExpanded] = React.useState(false);

  const filteredItems = items.filter(
    (amenity) =>
      !!AmenityV2Enum[
        Object.entries({
          [amenity]: amenity,
        })[0][0] as keyof typeof AmenityV2Enum
      ]
  );

  return (
    <div className={clsx([styles.amenityList, containerStyle])}>
      <div className={clsx([styles.amenityList__list, listStyle])}>
        {filteredItems
          .slice(0, isExpanded || showAll ? items.length : 9)
          .map((amenity, key) => (
            <AmenityV2
              key={`amenity-${key}`}
              item={{
                [amenity]: amenity,
              }}
            />
          ))}
      </div>

      {!showAll && filteredItems.length > 9 && (
        <div
          className={clsx([
            styles.amenityList__expand,
            isExpanded && styles.amenityList__expand__expanded,
          ])}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <ExpandAll />
          {isExpanded ? 'Hide' : 'Expand'}
        </div>
      )}
    </div>
  );
}
